var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTickSquare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.39102 0.666992H12.616C15.441 0.666992 17.3327 2.65033 17.3327 5.60033V12.4095C17.3327 15.3503 15.441 17.3337 12.616 17.3337H5.39102C2.56602 17.3337 0.666016 15.3503 0.666016 12.4095V5.60033C0.666016 2.65033 2.56602 0.666992 5.39102 0.666992ZM8.52435 11.492L12.4827 7.53366C12.766 7.25033 12.766 6.79199 12.4827 6.50033C12.1993 6.21699 11.7327 6.21699 11.4494 6.50033L8.00768 9.94199L6.54935 8.48366C6.26602 8.20033 5.79935 8.20033 5.51602 8.48366C5.23268 8.76699 5.23268 9.22533 5.51602 9.51699L7.49935 11.492C7.64102 11.6337 7.82435 11.7003 8.00768 11.7003C8.19935 11.7003 8.38268 11.6337 8.52435 11.492Z",
    fill: "#747B82"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickSquare);
export default __webpack_public_path__ + "static/media/TickSquare.750238e1.svg";
export { ForwardRef as ReactComponent };